/**
 * FoodPulseInventoryMarketing — public landing at `/food-pulse/inventory`.
 * Renders a long-form written process document above the visual feature
 * grid, so any visitor can read the perishable inventory playbook and
 * see the shipped feature list on the same page.
 */
import SmartInventoryFeatures from "@/components/SmartInventoryFeatures";
import PerishableInventoryDoc from "@/components/PerishableInventoryDoc";
import { Printer } from "lucide-react";

const CREAM = "#FBF7EF";
const GREEN = "#0F3D2E";

export default function FoodPulseInventoryMarketing() {
  return (
    <main className="min-h-screen" style={{ background: CREAM }} data-testid="fp-inventory-marketing">
      {/* Print CSS — strip chrome and visual grid, keep the written doc.
          Turning the doc into a PDF is a one-tap "Save as PDF" through
          the browser print dialog. */}
      <style>{`
        @media print {
          header, footer, .no-print { display: none !important; }
          body, main { background: white !important; }
          [data-testid="perishable-inventory-doc"] { border: none !important; padding: 0 !important; }
          a { color: black !important; text-decoration: none !important; }
          h1, h2, h3 { page-break-after: avoid; }
          p, ul, ol { orphans: 3; widows: 3; }
        }
      `}</style>

      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="no-print flex justify-end mb-4">
          <button
            onClick={() => window.print()}
            className="rounded-full px-4 py-2 text-sm font-semibold flex items-center gap-2"
            style={{ background: GREEN, color: CREAM }}
            data-testid="print-doc-btn"
          >
            <Printer size={16} /> Save as PDF · print
          </button>
        </div>
        <PerishableInventoryDoc />
      </div>
      <div className="max-w-6xl mx-auto px-4 pb-10 no-print">
        <SmartInventoryFeatures showHero={false} />
      </div>
    </main>
  );
}
